import { Button, Grid, TextField } from '@mui/material'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import BackdropLoader from './Components/General/Loader'
import SnackBar from './Components/General/SnackBar'
import MainCard from 'ui-component/cards/MainCard'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DownloadLogs, GetPaths } from 'API/Dev/api'

const LogMonitering = () => {
    const [Data,setData] =useState({"service_name":null,"date":new Date().toISOString().split("T")[0]})
    const [FetchData,setFetchData] =useState(null)
    const [Loading,setLoading] =useState(false)
    // const dummydata={
    //     "service_name":"mdm-admin-panel-api",
    //     "folder_name":"mdm_admin_panel_logs",
    //     "file_name":"mdm_admin_panel.log",
    // }

    const [AlertOpen,setAlertOpen] =useState(false)
    const [AlertMessage,setAlertMessage] =useState("")
    const [AlertType,setAlertType] =useState("success")

    const handleAlertOpen =(message,type)=>{
        setAlertOpen(true)
        setAlertMessage(message)
        setAlertType(type)
    }

    const handleAlertClose =()=>{
        setAlertOpen(false)
        setAlertMessage("")
        setAlertType("success")
    }

    const handleChange =(name,value)=>{
        if(name==="service_name"){
            if(value==="select"){
                setData({...Data,service_name:"",folder_name:"",file_name:""})
                return
            }
            else{
                let temp=FetchData.filter((item)=>item.service_name===value)[0]
                setData({...Data,service_name:value,folder_name:temp.folder_name,file_name:temp.file_name})
            }
            
        }
        else{

            setData({...Data,[name]:value})
        }
    }

    useEffect(()=>{
        GetPaths(setFetchData,setLoading,handleAlertOpen)
    },[])

    const handleDownload=()=>{
        if( Data.date && Data.service_name){
            let date = new Date(Data.date).toISOString().split("T")[0]
            console.log("date",date);
            
            DownloadLogs(Data,date,handleAlertOpen,setLoading)
        }
        else{
            handleAlertOpen("Please select all the fields","error")
        }
    }
    return (
        <MainCard title="Log Monitoring" sx={{ padding: "20px" }}>
            <BackdropLoader open={Loading} />
            <SnackBar open={AlertOpen} handleClose={handleAlertClose} message={AlertMessage} type={AlertType} />
            <Grid container spacing={2} sx={{ padding: "20px" }}>
                <Grid item xl={4} lg={4} md={4} xs={4}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Service Name</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={Data.service_name?Data.service_name:"select"}
                            label="Service Name"
                            onChange={(e)=>handleChange("service_name",e.target.value)}

                        >
                            <MenuItem value="select">Select</MenuItem>
                            {
                                FetchData && FetchData
                                .filter((item)=>item.service_name!=="")
                                .map((item,index)=>(
                                    <MenuItem key={index} value={item.service_name}>{item.service_name}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xl={4} lg={4} md={4} xs={4}>
                    <TextField 
                    id="outlined-basic" 
                    label="Outlined" 
                    variant="outlined"
                    type="date"
                    value={Data.date?Data.date:new Date()}
                    onChange={(e)=>handleChange("date",e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                      }}
                    fullWidth
                    inputProps={{
                        max: new Date().toISOString().split("T")[0]
                    }}
                    
                    />

                </Grid>

                <Grid container justifyContent="center" alignItems="center" spacing={2} mt={2}>
                    <Grid item xs={3}>
                        <Button fullWidth variant="contained" color="secondary" onClick={()=>handleDownload()}>Download</Button>
                    </Grid>
                </Grid>
            </Grid>
        </MainCard>
    )
}

export default LogMonitering